import {
	faCarrot,
	faFileInvoiceDollar,
	faList,
	faReceipt,
	faUserChef,
	faX,
} from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { tss } from 'tss-react';

import { RecipeErpViewComponentProps } from 'components/desktop/ShoppingCart/Detail/Index';
import InfoList from 'components/desktop/ShoppingCart/Detail/misc/InfoList';
import Receipt from 'components/desktop/ShoppingCart/Detail/misc/Receipt';
import StatusDot from 'components/desktop/ShoppingCart/Search/misc/StatusDot';
import { getPriceString } from 'functions/numberToString';
import useCurrency from 'hooks/redux/useCurrency';
import useTranslation from 'hooks/useTranslation';
import * as Person from 'types/ShoppingCart/Person';
import { ShoppingCart } from 'types/ShoppingCart/ShoppingCart';
import { getLabelTranslationKey } from 'types/ShoppingCart/Status';

interface IProps extends RecipeErpViewComponentProps {}

const OverviewCard = (props: IProps) => {
	const { classes, cx } = useStyles();
	const { t, cc } = useTranslation();
	const currency = useCurrency();

	return (
		<div className={classes.container}>
			<div className={classes.header}>
				<h2 className={classes.h2}>
					<FontAwesomeIcon icon={faList} className={classes.icon} />
					{t('shoppingCart:ORDER_OVERVIEW')}
				</h2>
				<Button size="sm" variant="light" onClick={props.handlers.toggleShowReceipt}>
					<FontAwesomeIcon
						icon={!props.state.showReceipt ? faReceipt : faX}
					></FontAwesomeIcon>{' '}
					{!props.state.showReceipt ? (
						<span>{t('shoppingCart:SHOW_RECEIPT')}</span>
					) : (
						<span>{t('shoppingCart:HIDE_RECEIPT')}</span>
					)}
				</Button>
			</div>
			<div className={classes.childContainer}>
				<div
					className={
						props.state.showReceipt
							? cx(classes.foldContainerOpen)
							: cx(classes.foldContainerClosed)
					}
				>
					<Receipt
						data={ShoppingCart.getReceiptData(props.cart, cc)}
						total={ShoppingCart.getTotalPrice(props.cart, cc)}
					/>
				</div>
				<div
					className={
						!props.state.showReceipt
							? cx(classes.foldContainerOpen)
							: cx(classes.foldContainerClosed)
					}
				>
					<InfoList
						title={t('shoppingCart:INGREDIENTS')}
						icon={faCarrot}
						data={ShoppingCart.getIngredientsData(props.cart, cc)}
					/>
					<hr />
					<div className={classes.footer}>
						<div className={classes.footerBox}>
							<h3 className={classes.h3}>
								<FontAwesomeIcon icon={faFileInvoiceDollar}></FontAwesomeIcon>{' '}
								{t('shoppingCart:ESTIMATED_BILL')}
							</h3>
							<div className={classes.price}>
								{getPriceString(ShoppingCart.getTotalPrice(props.cart, cc), cc)}{' '}
								<span style={{ fontSize: '0.7em' }}>{currency}</span>
							</div>
						</div>
						<div className={classes.lineHorizontal}></div>
						<div className={classes.footerBox}>
							<h3 className={classes.h3}>
								<FontAwesomeIcon icon={faUserChef}></FontAwesomeIcon>{' '}
								{t('shoppingCart:RESPONSIBLE')}
							</h3>
							<div>{props.cart.admin ? Person.getName(props.cart.admin) : '–'}</div>
							<hr style={{ margin: '0.5em 0' }} />
							<div>
								<strong>
									<StatusDot
										status={props.cart.status}
										style={{ marginRight: '5px' }}
									/>
									{t('shoppingCart:STATUS')}:{' '}
								</strong>
								{t(getLabelTranslationKey(props.cart.status))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OverviewCard;

export const useStyles = tss.create({
	container: {
		padding: '12px 16px',
		border: '1px solid #ccc',
		borderRadius: '6px',
		backgroundColor: '#fafafa',
		boxShadow: '0px 0px 5px #ccc',
		width: '100%',
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	showReceiptButton: {
		cursor: 'pointer',
	},
	hr: {
		marginTop: '22px',
		marginBottom: '16px',
	},
	childContainer: {
		padding: '16px 16px',
	},
	icon: {
		marginRight: '8px',
	},
	h2: {
		fontSize: '1.3em',
		color: '#6999CC',
	},
	h3: {
		fontSize: '1.1em',
		fontWeight: 'bold',
	},
	price: {
		fontSize: '2.0em',
		fontWeight: 'bold',
	},
	footer: {
		display: 'flex',
	},
	footerBox: {
		flexGrow: 1,
	},
	lineHorizontal: {
		minHeight: '100%',
		width: '1px',
		backgroundColor: '#999',
		margin: '0 10px',
	},
	foldContainerClosed: {
		maxHeight: '0',
		overflow: 'hidden',
		transition: 'max-height 0.5s cubic-bezier(0.86, 0, 0.07, 1)',
	},
	foldContainerOpen: {
		maxHeight: '45rem',
		overflow: 'hidden',
		transition: 'max-height 0.5s cubic-bezier(0.86, 0, 0.07, 1)',
	},
});
